import { ModalFooter } from "@hostingbv/lib/src/components/layout/ModalProvider";
import { FC } from "react";
import { SshKey } from "@hostingbv/lib/src/api/partner/models/SshKey";
import { Loading } from "@hostingbv/lib/src/components/Loading";
import { config } from "../config";
import { useApiClient } from "@hostingbv/lib/src/api";
import { useRefresh } from "@hostingbv/lib/src/components/RefreshController";
import { useNavigate } from "react-router-dom";
import { faTrash } from "@fortawesome/free-solid-svg-icons";


export const DeleteSshKeyModal: FC<{ publicKey: SshKey | null }> = (props) => {
  const { partnerClient } = useApiClient(config)
  const reload = useRefresh()
  const navigate = useNavigate()
  const confirm = async () => {
    if (props.publicKey === null) return
    await partnerClient.deleteSshKey(props.publicKey.id)
    reload()
    navigate('/ssh-keys')
  }

  return <Loading loading={props.publicKey === null}>
    {props.publicKey && <>
      <p className={""}>
        <strong>Caution!</strong> You are about to delete the SSH key <strong>{props.publicKey.displayName}</strong> from your account.
        All access granted to this key will be revoked and the key will be deleted from our systems.
      </p>
      <p className={"mt-4"}>
        This key is currently has access to <strong>{props.publicKey.uses}</strong> resource(s).
      </p>
      <ModalFooter icon={faTrash} text={"Revoke & delete"} onSubmit={confirm} />
    </>}
  </Loading>
}
